import { useCallback } from 'react';
import { postJson } from '../utils/apiClient';
import { applyItemOptimisticImage, revertItemOptimisticImage } from '../utils/optimistic';
import { isTempId } from '../utils/id';

export const usePhotoActions = (listId, setCache, { onClosePhotoModal } = {}) => {
  const analyzePhoto = useCallback(async (base64) => {
    if (isTempId(listId)) {
      alert('Please wait for the list to be created before analyzing photos.');
      return;
    }
    try {
      const { data } = await postJson(`/lists/${listId}/items/photo`, { photoData: base64 });
      if (data.items && data.items.length > 0 && onClosePhotoModal) {
        setTimeout(() => onClosePhotoModal(), 500);
      }
      return data;
    } catch (error) {
      console.error('📷 [Photo Analysis] Error:', error);
      alert('Failed to analyze photo: ' + (error.response?.data?.message || error.message));
      throw error;
    }
  }, [listId, onClosePhotoModal]);

  const attachItemImage = useCallback(async (itemId, base64) => {
    if (isTempId(listId)) {
      alert('Please wait for the list to be created before adding images.');
      return;
    }
    try {
      applyItemOptimisticImage(setCache, listId, itemId, base64);
      const { data } = await postJson(`/lists/${listId}/items/${itemId}/image`, { imageData: base64 });
      return data;
    } catch (error) {
      revertItemOptimisticImage(setCache, listId, itemId);
      alert('Failed to add image to item: ' + (error.response?.data?.message || error.message));
      throw error;
    }
  }, [listId, setCache]);

  return { analyzePhoto, attachItemImage };
};

export default usePhotoActions;


